









































import { defineComponent, computed } from '@vue/composition-api'

import { Gender, IReceipt, supplierName } from '@/types/receipt'
import { AppInput, AppIcon, MasterAutocomplete } from '@/components/atoms'

type Props = {
  receipt: IReceipt
}

export default defineComponent({
  name: 'MetaTable',
  components: { AppInput, AppIcon, MasterAutocomplete },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    const details = computed(() => {
      return [
        {
          label: 'OKリンカーID',
          value: props.receipt.okedByLinkerId,
        },
        {
          label: 'NGリンカーID',
          value: props.receipt.ngedByLinkerId,
        },
        {
          label: 'OKリーダーID',
          value: props.receipt.okedByLeaderId,
        },
        {
          label: 'NGリーダーID',
          value: props.receipt.ngedByLeaderId,
        },
      ]
    })
    const metas = computed(() => {
      return [
        {
          label: '流入元',
          value: supplierName(props.receipt.supplier),
        },
        {
          label: 'ID',
          value: props.receipt.monitorId || '',
        },
        {
          label: '性別',
          value:
            props.receipt.monitorGender === Gender.MALE
              ? '男性'
              : props.receipt.monitorGender === Gender.FEMALE
              ? '女性'
              : 'その他',
        },
        {
          label: '年齢',
          value: props.receipt.monitorAge || '',
        },
        {
          label: '都道府県',
          value: props.receipt.monitorPrefecture || '',
        },
        {
          label: '既婚',
          value:
            props.receipt.monitorIsMarried === null
              ? ''
              : props.receipt.monitorIsMarried
              ? 'Yes'
              : 'No',
        },
      ]
    })

    return {
      details,
      metas,
    }
  },
})
